import { GetTagHistory } from './GetTagHistory';
import { ListTags } from './ListTags';

/**
 * queries
 *
 * @type {{GetTagHistory: ((function({}=): Promise<*>)|*), ListTags: ((function({}=): Promise<*>)|*)}}
 */
export const queries = {
  GetTagHistory,
  ListTags,
};
